import _ from 'underscore';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { FeatureFlags } from '../../../ts/FeatureFlags';
import { ServerUrls } from '../../ServerUrls';

export namespace BasePathsUtils {
  export function getWatchedBasePathsForServer() {
    const serverUrls = ServerUrls.getInstance();
    return _.compact([
      serverUrls.sitesPath(),
      serverUrls.jobsPath(),
      serverUrls.schedulesPath(),
      serverUrls.baseUserPath(),
      serverUrls.serverStatusVizPath(''),
      serverUrls.settingsExtensionsPath(),
      serverUrls.settingsLicensesPath(),
      serverUrls.settingsPath(),
      serverUrls.settingsCustomizationPath(),
      serverUrls.addSitePath(),
      serverUrls.statusPath(),
      serverUrls.tasksPath()
    ]);
  }

  export function getWatchedBasePathsForSite(urls: SpacesSiteUrls) {
    let redirectToDataSourcePath = urls.favoriteDatasourcePath('', '');
    // this returns /redirect_to_datasource// which doesn't actually match /redirect_to_datasource/12/342 so trim
    // the last /
    redirectToDataSourcePath = redirectToDataSourcePath.substr(0, redirectToDataSourcePath.length - 1);

    return _.compact<_.List<string | false>>([
      urls.baseUserPath(),
      urls.usersPath(),
      urls.favoritesPath(),
      urls.recentsPath(),
      urls.projectPath(''),
      urls.datasourcePath(''),
      urls.flowPath(''),
      urls.publishedConnectionPath(''),
      urls.workbookPath(''),
      urls.workbooksPath(),  // this also handles the revision history paths
      urls.dataRolesPath(),
      urls.lensesPath(),
      urls.searchPath(),
      urls.groupsPath(),
      urls.homePath(),
      urls.recommendationListPath(),
      urls.metricsPath(),
      urls.dataRolePath(''),
      urls.lensPath(''),
      urls.statusPath(),
      urls.explorePath(),
      urls.projectsPath(),
      urls.flowsPath(),
      urls.publishedConnectionsPath(),
      urls.viewsPath(),
      urls.datasourcesPath(),
      urls.tasksPath(),
      FeatureFlags.jobManagementEnabled && urls.jobsPath(),
      urls.schedulesPath(),
      urls.redirectToViewPath(''),
      urls.redirectToFavoriteViewPath(''),
      urls.redirectToDataRolePath(''),
      urls.redirectToWorkbookPath(''),
      urls.redirectToFlowPath(''),
      urls.redirectToPublishedConnectionPath(''),
      urls.redirectToProjectPath(''),
      urls.exploreDatasourcePath(''),
      redirectToDataSourcePath,
      urls.metricPath(''),
      urls.dataAlertPath(), // for remove and add data alerts
      urls.catalogPath(),
      urls.siteStatusVizPath(''),
      urls.settingsPath(),
      urls.settingsExtensionsPath(),
      urls.settingsBridgePath(),
      urls.settingsAuthenticationPath(),
      urls.redirectToMetricPath(''),
      urls.collectionsPath(),
      urls.startersPath(),
      FeatureFlags.sharedWithMeBasicEnabled && urls.sharedWithMePath(),
      urls.personalSpacePath(),
      FeatureFlags.prometheusPredictiveModelEnabled && urls.predictiveModelsPath(),
      FeatureFlags.prometheusPredictiveModelEnabled && urls.predictiveModelPath(''),
    ]);
  }
}
